import type { RouteRecordRaw } from 'vue-router'
import { guardMyLettagaSubscription } from '@/features/myLettaga/composables/useMyLettagaAccess'

/**
 * Unified Settings — single shell (SettingsLayout) with a grouped left sub-nav and
 * per-section child routes. Section content REUSES existing components (no rewrite).
 * Operational features (Reminder, Documents/Templates, My Lettaga) stay in their own nav.
 */
const sectionMeta = { requiresAuth: true, layout: 'full' as const }

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    component: () => import('./views/SettingsLayout.vue'),
    meta: { ...sectionMeta, title: 'Settings', titleKey: 'settings.title' },
    children: [
      { path: '', redirect: '/settings/company' },
      // Workspace
      { path: 'company', name: 'SettingsCompany', meta: sectionMeta, component: () => import('@/features/company-settings/components/BasicInfoTab.vue') },
      { path: 'billing', name: 'SettingsBilling', meta: sectionMeta, component: () => import('@/features/company-settings/components/BillingTab.vue') },
      { path: 'entities', name: 'SettingsEntities', meta: sectionMeta, component: () => import('@/features/company-settings/components/EntityStatusTab.vue') },
      { path: 'users', name: 'SettingsUsers', meta: sectionMeta, component: () => import('@/features/users/views/UserListPage.vue') },
      { path: 'authorisation', name: 'SettingsAuthorisation', meta: sectionMeta, component: () => import('@/features/authorization-settings/views/AuthorizationSettingsPage.vue') },
      // Product
      // 미구독 시 진입 자체를 막고 구독 안내 모달만 제공(Settings로 이동하지 않음). 좌측메뉴/서브내비 공통 초크포인트.
      {
        path: 'my-lettaga', name: 'SettingsMyLettaga', meta: sectionMeta,
        beforeEnter: async (_to, from, next) => {
          const { allowed, redirectTo } = await guardMyLettagaSubscription()
          if (allowed) return next()
          if (redirectTo) return next(redirectTo)
          // 미구독 + 취소: 이전 위치 유지. 최초 진입(이전 라우트 없음)이면 대시보드로.
          if (from && from.name) return next(false)
          return next('/dashboard')
        },
        component: () => import('@/features/myLettaga/views/SettingsView.vue')
      },
      // Personal
      { path: 'account', name: 'SettingsAccount', meta: sectionMeta, component: () => import('@/features/account-settings/components/AccountTab.vue') },
      { path: 'security', name: 'SettingsSecurity', meta: sectionMeta, component: () => import('@/features/account-settings/components/SecurityTab.vue') },
    ]
  }
]
